module.exports = __webpack_public_path__ + "static/media/rtf.1b148ca4.svg";